<template>
  <div>
    <div class="back-box">
      <Button type="primary" @click="backPage()">返回</Button>
    </div>
    <iframe style="height: 95vh; width: 100%" :src="url" frameborder="0"></iframe>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  data() {
    return {
      url: ''
    };
  },

  created() {
    this.url = this.$route.query.url;
  },

  methods: {
    backPage() {
      this.back('/trainingCourse/courseOnline');
    }
  }
};
</script>

<style lang="scss" scoped>
.back-box {
  background: #fff;
  display: flex;
  Button {
    margin: 10px 0;
    margin-right: 10px;
    margin-left: auto;
  }
}
</style>
